module.exports = __webpack_public_path__ + "assets/img/low.a37e85d8.png";